import { modeContext } from 'components/Contexts/contexts';
import { useContext, useState, useEffect } from 'react';
import classes from './ToggleMenuButton.module.css';
import Tooltip from 'ui/Tooltip';

export const ToggleMenuButton = () => {
  const { mode } = useContext(modeContext);
  const { fullMenu, setFullMenu } = mode;

  const [styleButton, setStyleButton] = useState({ transform: 'rotate(90deg)' });
  useEffect(() => {
    if (!fullMenu) setStyleButton({ transform: 'rotate(-90deg)' });
    else setStyleButton({ transform: 'rotate(90deg)' });
  }, [fullMenu]);

  function setFM() {
    if (fullMenu) {
      setFullMenu(false);
    } else {
      setFullMenu(true);
    }
  }

  return (
    <Tooltip text={fullMenu ? 'Свернуть' : 'Развернуть'}>
      <img
        id={'header_button'}
        className={classes.Header_button_menu}
        alt={'alt'}
        src={'/svg/arrow-01.svg'}
        style={styleButton}
        onClick={() => setFM()}
      />
    </Tooltip>
  );
};

export default ToggleMenuButton;
